import React from 'react';
import { motion } from 'framer-motion';
import { User, Heart, Store, FileText } from 'lucide-react';
const audiences = [{
  icon: User,
  text: 'Para quienes quieren aprender desde cero sin sentirse abrumados.'
}, {
  icon: Heart,
  text: 'Para quienes extrañan el sabor auténtico de la panadería latina.'
}, {
  icon: Store,
  text: 'Para quienes quieren vender pan casero y necesitan resultados consistentes.'
}, {
  icon: FileText,
  text: 'Para quienes están cansados de recetas confusas y buscan claridad.'
}];
export function WhoIsThisFor() {
  return <section className="py-24 bg-beige" data-id="element-231">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-232">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-233">
          <h2 className="text-4xl md:text-5xl font-bold text-espresso" data-id="element-234">
            ¿Para quién es este ebook?
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-235">
          {audiences.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-warm-white p-8 text-center shadow-sm hover:shadow-md transition-shadow duration-300 border-t-4 border-terracotta" data-id="element-236">
              <div className="w-16 h-16 mx-auto bg-beige text-espresso flex items-center justify-center rounded-full mb-6" data-id="element-237">
                <item.icon size={28} strokeWidth={1.5} data-id="element-238" />
              </div>
              <p className="text-espresso/90 font-medium leading-relaxed" data-id="element-239">
                {item.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}